import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ColumnSortService {
  constructor() { }

  private columnSortedSource = new Subject<ColumnSortedEvent>();

  columnSorted$ = this.columnSortedSource.asObservable();

  columnSorted( event: ColumnSortedEvent ) {
    this.columnSortedSource.next( event );
  }
}

export interface ColumnSortedEvent {
  sortColumn: string;
  sortDirection: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/services/column-sort.service.ts